import Head from 'next/head';

import {HeadSEO} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';

import {PageProps} from 'src/types/page-props';

import {useSetupNavigation} from '../../hooks/use-setup-navigation';
import {useCanonicalUrl} from '../../hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from '../../lib/constants';
import {BlackFridayLandingPage} from './black-friday-cyber-monday-sales.react-component';
import {CertificationAggregatorData, SimpleTopic, HottestTopic, AcademiesList} from './types';

export type InternalProps = {
    hottestTopicsList: Array<HottestTopic>;
    topicsList: Array<SimpleTopic>;
    academies: AcademiesList;
    certificationAggregatorData: CertificationAggregatorData | null;
};

export type BlackFridayCyberMondaySalesPageFeatureProps = PageProps & InternalProps;

export const BlackFridayLandingPageFeature: React.FC<
    BlackFridayCyberMondaySalesPageFeatureProps
> = (props) => {
    const {gettext} = useI18n();
    const {url: canonicalUrl} = useCanonicalUrl([], META_DEFAULT_BASE_URL);
    useSetupNavigation();

    const metaProps = {
        title: gettext('Black Friday Cyber Monday Sales | Udemy'),
        description: gettext(
            'Save big on your next course during Udemy’s Black Friday Cyber Monday sale!',
        ),
    };

    return (
        <>
            <HeadSEO
                title={metaProps.title}
                ogTitle={metaProps.title}
                description={metaProps.description}
                ogDescription={metaProps.description}
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <BlackFridayLandingPage {...props} />
        </>
    );
};
